module.exports = __webpack_public_path__ + "img/activity_2_consult.87d790a0.jpg";